module.exports = __webpack_public_path__ + "img/bzbf5@2x.7df0ef11.png";